import React, { useRef, useState } from "react";
import { orderBy } from "lodash";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import { Row, Col } from "react-bootstrap";
import { Input, Select } from "formsy-react-components";
import DropdownSearch from "../common/DropdownSearch";

const ContractTierForm = ({
  adding,
  contractTier,
  onSave,
  onCancel,
  codes
}) => {
  const [isValidForm, setIsValidForm] = useState(false);
  const [contractType, setContractType] = useState(contractTier.contract_type);
  let form = useRef();

  const handleAdd = (values) => {
    form.reset();
    values.contract_type = contractType;
    onSave(values);
  };

  const handleEdit = (values) => {
    values.id = contractTier._id;
    values.contract_type = contractType;
    form.reset();
    onSave(values);
  };

  const onChange = (name, { value }) => {
    setContractType(value);
  };

  const generateCodeOptions = (field) => {
    const codeOptions = codes
      .filter((code) => code.entity === "Contract" && code.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label
      }));

    return orderBy(codeOptions, "label");
  };

  return (
    <Formsy
      ref={(ref) => (form = ref)}
      className="vertical form"
      onValidSubmit={adding ? handleAdd : handleEdit}
      onValid={() => setIsValidForm(true)}
      onInvalid={() => setIsValidForm(false)}
    >
      <Row>
        <Col md={3}>
          <Input
            required
            disabled={!adding}
            name="value"
            label="Value"
            placeholder="Value"
            value={contractTier.value || ""}
            validations={{ maxLength: 255 }}
            validationErrors={{
              maxLength: "You can not type in more than 255 characters"
            }}
          />
        </Col>
        <Col md={3}>
          <Input
            required
            name="label"
            label="Label"
            placeholder="Label"
            value={contractTier.label || ""}
            validations={{ maxLength: 255 }}
            validationErrors={{
              maxLength: "You can not type in more than 255 characters"
            }}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            required
            name="contract_type"
            label="Contract Type"
            onChange={onChange}
            value={contractType}
            data={[...generateCodeOptions("type")]}
          />
        </Col>
        <Col md={3}>
          <Select
            label="Status"
            name="status"
            value={contractTier.status}
            options={[
              { label: "Active", value: "true" },
              { label: "Inactive", value: "false" }
            ]}
          />
        </Col>
        <Col md={4}>
          <Input
            required
            name="low_sla"
            label="Low SLA"
            placeholder="Low SLA"
            type="number"
            value={contractTier.low_sla?.toString() || ""}
          />
        </Col>
        <Col md={4}>
          <Input
            required
            name="normal_sla"
            label="Normal SLA"
            placeholder="Normal SLA"
            type="number"
            value={contractTier.normal_sla?.toString() || ""}
          />
        </Col>
        <Col md={4}>
          <Input
            required
            name="high_sla"
            label="High SLA"
            placeholder="High SLA"
            type="number"
            value={contractTier.high_sla?.toString() || ""}
          />
        </Col>
        <Col md={12} className="footer">
          <button
            type="button"
            style={!adding ? { display: "inline" } : { display: "none" }}
            className="btn  btn-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <input
            className="btn btn-success"
            type="submit"
            disabled={!isValidForm}
            value="Save"
          />
        </Col>
      </Row>
    </Formsy>
  );
};
ContractTierForm.propTypes = {
  adding: PropTypes.bool,
  contractTier: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  codes: PropTypes.array
};

export default ContractTierForm;
